export const artistsPage = {
    'artists.card.image.title': 'Artist - {shortId} | Find more interesting artists for you on R.Toys',
    'artists.page.title': 'Artists',
}
